import { SVGProps } from "react";

export const Bolt = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 -990 990 990" {...props}>
      <path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z" />
    </svg>
  );
};
